import { action } from '@ember/object';
import Component from '@glimmer/component';

interface UiInputGroupInputSignature {
  Element: HTMLInputElement;
  Args: {
    Named: {
      id: string;
      iconLeft?: string;
      hasError?: boolean;
      ariaDescribedby?: string;
      iconRight?: string;
      value?: string;
      onIconRightClick?: () => void;
    };
  };
}

export default class UiInputGroupInputComponent extends Component<UiInputGroupInputSignature> {
  @action
  onIconRightClick() {
    this.args.onIconRightClick?.();
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::InputGroup::Input': typeof UiInputGroupInputComponent;
    'ui/input-group/input': typeof UiInputGroupInputComponent;
  }
}
